export default __webpack_public_path__ + "static/media/twitterIcon.a01fc147.png";